import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';

export const NotAllowed: FC = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      height="100dvh"
      color="text.primary"
      flex={1}
    >
      <Box textAlign="center">
        <Typography typography="h1" p={2} fontSize="100px">
          403
        </Typography>
        <Typography typography="h2" p={1}>
          You are not allowed to see this page
        </Typography>
      </Box>
    </Box>
  );
};
